
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DayManager from "../DayManager"; // Import DayManager component
import { doSignOut } from "../../firebase/auth";
import { useAuth } from "../../contexts/authContext";
import { makeAuthenticatedRequest } from "../../utils/apiRequest";
const CustomerSelectionPage = () => {
  const [customers, setCustomers] = useState([]); // State to hold customer data
  const [selectedCustomer, setSelectedCustomer] = useState(""); // State for the selected customer
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [error, setError] = useState(null); // Error state
  const location = useLocation(); // Access location state
  const navigate = useNavigate();
  // Extract token and editData from location state
   const { token } = useAuth();
  const editData = location.state?.editData;
  const handleLogout = async () => {
    await doSignOut();
    setTimeout(() => {
      navigate("/login", { replace: true }); // Use replace to avoid back navigation
    }, 100); // Add a short delay
  };
  
  
  // Fetch customers from the API
  const fetchCustomers = async () => {
    console.log("Fetching customers...");
    if (!token) {
      console.error("Authorization token is missing.");
      setError("Authorization token is missing.");
      handleLogout(); // Auto logout if the token is missing
      return;
    }

    console.log("Customer Using token:", token); // Added to print the token
  
    setIsLoading(true);
    setError(null);
    try {
      const response = await makeAuthenticatedRequest(
        "https://us-central1-evoq-travel-craft.cloudfunctions.net/get_customer_data",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      if (!response.ok) {
        if (response.status === 401) {
          console.error("Unauthorized access. Logging out...");
          handleLogout(); // Auto logout on unauthorized access
          return;
        }
        throw new Error(`Failed to fetch customers, status: ${response.status}`);
      }
  
      const data = await response.json();
      console.log("Customer data fetched successfully:", data);
  
      if (Array.isArray(data.data)) {
        setCustomers(data.data);
        console.log("Parsed customers:", data.data);
      } else {
        console.error("Unexpected customer data format:", data);
        setError("Unexpected customer data format.");
      }
  
      if (editData) {
        console.log(
          "Preselecting customer from editData:",
          editData.customer_id
        );
        setSelectedCustomer(editData.customer_id);
      }
    } catch (err) {
      console.error("Error fetching customers:", err.message);
      setError("Failed to fetch customers.");
    } finally {
      setIsLoading(false);
    }
  };
  

  // Fetch customers on component mount
  useEffect(() => {
    console.log("Component mounted. Token:", token);
    fetchCustomers();
  }, [token]);

  // Automatically select customer and render DayManager if editing
  useEffect(() => {
    if (editData && editData.customer_id) {
      console.log(
        "Setting selected customer from editData:",
        editData.customer_id
      );
      setSelectedCustomer(editData.customer_id);
    }
  }, [editData]);

  // Handle customer selection
  const handleCustomerSelect = (event) => {
    const customerId = event.target.value;
    console.log("Customer selected:", customerId);
    setSelectedCustomer(customerId);
  };

  return (
    <>
      <div className="p-12 w-full dark:bg-gray-900 dark:text-white">
        {/* Pass editData to DayManager */}
        <DayManager
          token={token}
          customerId={selectedCustomer}
          customerName={
            customers.find(
              (customer) => customer.customer_id === selectedCustomer
            )?.name || "Unknown Customer"
          }
          editData={editData} // Pass itinerary data for editing
        />
      </div>
    </>
  );
};

export default CustomerSelectionPage;